import { render, staticRenderFns } from "./ExtraHealthPlans.vue?vue&type=template&id=188e51c4&scoped=true"
import script from "./ExtraHealthPlans.vue?vue&type=script&lang=js"
export * from "./ExtraHealthPlans.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ExtraHealthPlans.vue?vue&type=style&index=1&id=188e51c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e51c4",
  null
  
)

export default component.exports